/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Image_BadInputs */

const en_landing_studio_image_bad = /** @type {(inputs: Landing_Studio_Image_BadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a JPG, PNG or WebP image.`)
};

const zh_landing_studio_image_bad = /** @type {(inputs: Landing_Studio_Image_BadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请使用 JPG、PNG 或 WebP 图片。`)
};

/**
* | output |
* | --- |
* | "Use a JPG, PNG or WebP image." |
*
* @param {Landing_Studio_Image_BadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_image_bad = /** @type {((inputs?: Landing_Studio_Image_BadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Image_BadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_image_bad(inputs)
	return zh_landing_studio_image_bad(inputs)
});
export { landing_studio_image_bad as "landing.studio.image_bad" }